import Head from 'next/head';
import Index from '@@/containers/pc/home/components/News/components/NewsDetail';
import { store, reducer } from '@@/store/home';
import { getPageData } from '@/model/page';
import BaseController from '@/model/base';
import HeadSeo from '@/components/head-seo';
import StoreProvider from '@/components/store-provider';

const controller = new BaseController('news');

export default ({ pageData, ...props }) => {
  return (
    <>
      <HeadSeo image={pageData?.page?.share_img?.[0]?.value} />
      <Head>
        <script
          dangerouslySetInnerHTML={{
            __html: `
          document.documentElement.classList.add('pc-app');
          var isIpad = function () {
            var platform = navigator.platform === 'MacIntel' || navigator.platform === 'iPad'
            return platform && navigator.maxTouchPoints > 1
          };
          if (isIpad()) {
            var pathnameArray = window.location.pathname;
            if (pathnameArray.indexOf('/m') === -1) {
              window.location.href =
                window.location.href.split("#")[0]
                + (window.location.search ? '&target=h5' : '?target=h5')
                + window.location.hash;
            }
          }
            `,
          }}
        />
      </Head>
      <StoreProvider store={store} reducer={reducer}>
        <Index {...props} />
      </StoreProvider>
    </>
  );
};

export const getServerSideProps = async ({ params, query, req }) => {
  let data = {};
  let res = {};
  let pageData = {};
  try {
    const { id } = params;
    const host = req.headers.host;
    const columns = ['title', 'publish_time', 'id', 'section'];
    let sql = '';
    if (query.token && (query.token === process.env.revalidate_token) && (host.includes('-pre') || host.includes('-test'))) {
      columns.push('content_edit');
      sql = `id = ${Number(id)}`;
    } else {
      columns.push('content_html');
      sql = `id = ${Number(id)} AND publish_time <= NOW() AND status=1`;
    }

    ([res, pageData] = await Promise.all([controller.queryByParams({
      where: sql,
      columns,
      limit: 1,
      offset: 0,
    }, false), getPageData()]));

    const obj = res.data[0];
    Object.keys(obj).forEach((key) => {
      if (key === 'publish_time') {
        data[key] = new Date(obj[key]).valueOf();
      } else {
        data[key] = obj[key];
      }
    });
  } catch (err) {
    console.log(err);
  }
  return {
    props: {
      data,
      pageData,
    },
  };
};
